import { render, staticRenderFns } from "./InCaseYouMissedItSection.vue?vue&type=template&id=735dba2a&"
import script from "./InCaseYouMissedItSection.vue?vue&type=script&lang=js&"
export * from "./InCaseYouMissedItSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports